var UIEdit = {
	node :null,
	current: null,

	init: function() {
		UIEdit.node = $("<div id='UiEditor' class='cms-editor'></div>");

		if (player.cms) {
			UIEdit.node.append(TPL.render("uielement-edit-main", {}));
			$("#overlay").append(UIEdit.node);

			UIEdit.addUIElementButton = $("<a href='javascript:void(null);' onclick='UIEdit.openSelectMenu();'><i class='fa fa-edit'></i><Br>Dodaj element</a>");
			player.cmsnode.prepend(UIEdit.addUIElementButton);
		}
	},

	openSelectMenu: function() {
		UIEdit.addUIElementButton.addClass("selected");
		Cms.root.$refs.selectcomponent.open();
	},

	add: function(t, params) {

		var ind = HotSpotManager.spots.length + 1;

		var uie = new UIElement($("#player").width() * 0.5, $("#player").height() * 0.5);		

		if (t != undefined) {
			uie.type = t;
			uie.build(params);
		}

		ElementManager.add(uie);

		if (player.cms) {
			//uie.node.append("<div class='indicator_selected'></div>");
			uie.editor.addUI();
		}

		UIEdit.select(uie.editor);

		//SpotEdit.select(spot.editor);
	},
	
	deselect: function() {
		UIEdit.current.hs.node.removeClass("element_selected");
		UIEdit.current = null;
	},

	select: function(s) {

		/*
		UIEdit.node.removeClass("open");

		setTimeout(function() {
			UIEdit.node.addClass("open");
		}, 100);
		*/		

		if (UIEdit.current !== s) {
			if (UIEdit.current != null) UIEdit.current.hs.node.removeClass("element_selected");
			UIEdit.current = s;

			Cms.root.$refs.uiedit.open(s);

			//s.hs.node.find(".indicator_selected").show();
			s.hs.node.addClass("element_selected");

			/*
			$("#se_title").val(s.hs.indicator.title);
			$("#se_no").val(s.hs.indicator.no);
			$("#se_title2").val(s.hs.indicator.title2);
			$("#se_info").val(s.hs.indicator.info);
			$("#se_x").val(s.hs.indicator.look_x);
			$("#se_y").val(s.hs.indicator.look_y);
			*/
		}
	},

	updateCoords: function(x,y) {
		$("#se_x").val(x);
		$("#se_y").val(y);
		SpotEdit.current.hs.indicator.look_x = x;
		SpotEdit.current.hs.indicator.look_y = y;
	},

	save: function() {
		var fields = {};		

		UIEdit.current.hs.videourl = $("#uie_videourl").val();
		UIEdit.current.hs.build();
		/*
		fields['look_x'] = parseFloat($("#se_x").val()) - parseFloat(player.current.properties.north) + 95;
		fields['look_y'] = $("#se_y").val();
		fields['title'] = $("#se_title").val();
		fields['no'] = $("#se_no").val();
		fields['title2'] = $("#se_title2").val();
		fields['info'] = $("#se_info").val();
		fields['place_id'] = player.ident;
		fields['id'] = SpotEdit.current.hs.indicator.id;

		SpotEdit.updateContent(fields['title'], fields['no'], fields['title2'], fields['info']);

		$.post("/cms/index.php?mod=Panorama&action=addIndicator&ajax=1&pano=" + player.ident, fields, function(response) {
			console.log(response);
			if (fields['id'] == undefined || fields['id'] == null) {
				fields['id'] = response.indicator.id;
				SpotEdit.current.hs.indicator.id = response.indicator.id;
			}
			//alert("Zapisano");
		});
		*/
	},

	remove: function() {
		if (confirm("Czy na pewno chcesz usunąć tą tabliczkę ?")) {
			SpotEdit.current.hs.remove();
			$("#SpotEditor").removeClass("open");
			if (SpotEdit.current.hs.indicator.id != undefined && SpotEdit.current.hs.indicator.id != null && SpotEdit.current.hs.indicator.id > 0) {
				$.get("/cms/index.php?mod=Panorama&action=removeind&ajax=1&pano=" + player.ident + "&id=" + SpotEdit.current.hs.indicator.id, function(response) {
					console.log(response);
				});
			}
		}
	},

	placeReady: function(pe) {
	},

	process: function() {
	},

	selectMedia: function() {
		$("#uie_media").click();
	},

    uploadfile: function(data) {
        var file;

        this.input = $("#uie_media").get(0);

        this.uploading = true;
        this.upfiles = this.input.files;
        this.progress = 0;

        var file = this.upfiles[0];

        var self = this;

        $.ajax({
            url: "/uploadres.php?fileName=" + file.name + "&mimeType=" + file.type,
            type: "POST",
            data: file,
            processData: false,
            contentType: file.type,
            
            success: function(data) {
            },
            error: function(err) {
                alert("Unable to upload file " + file.name);
            },

            xhr: function() {
                var myXhr = $.ajaxSettings.xhr();
                //var self = this;

                if(myXhr.upload){
                    myXhr.upload.addEventListener('progress',function(evt) {                        
                        self.progress = (evt.loaded / evt.total) * 100;
                        if (self.progress < 100)
                            $("#uie_console").html("Uploading " + self.progress + "%");
                        else 
                            $("#uie_console").html("Processing ... Please wait.");
                    }, false);
                } else {
                    console.log("Upload progress is not supported.");
                }
                return myXhr;
            }   
        });

    }, 	
}

PluginManager.add(UIEdit);